import axios from 'axios';

const baseURL = `//${window.location.hostname}/api`
	.replace('consent', 'api')
	.replace('localhost', 'localhost:4000')
	.replace('127.0.0.1', 'localhost:4000')
	.replace('stg', 'stg2');

const api = axios.create({ baseURL });

export default api;
